import { MatchListItemFragment } from '../../generated/graphql';
import { deriveKitColor } from '../../utils/deriveKitColor';
import { gradientColorString } from '../../utils/gradientColorString';

export const getKitIconBackgroundStyle = (kitName: string) => {
  const kitColors = deriveKitColor(kitName);
  return kitColors.length
    ? `repeating-linear-gradient(135deg, ${gradientColorString(kitColors)})`
    : 'black';
};

export const getScoreInfo = (
  match: Pick<
    MatchListItemFragment,
    'atHome' | 'goalsFor' | 'goalsAgainst' | 'opponent' | 'team'
  >,
) => {
  return match.atHome
    ? {
        homeTeam: match.team.name,
        homeGoals: match.goalsFor,
        awayGoals: match.goalsAgainst,
        awayTeam: match.opponent,
      }
    : {
        homeTeam: match.opponent,
        homeGoals: match.goalsAgainst,
        awayGoals: match.goalsFor,
        awayTeam: match.team.name,
      };
};
